import { useMemo } from 'react';
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _sortBy from 'lodash/sortBy';
import { formatChartDate, getBoundaryTimestamps } from '@/shared/utils/dateFormatters';
import { useGetTransactionsSharedQuery } from '@/shared/api/Payouts';
import {
  SORT_BY,
  ORDER,
  STATUSES,
  LIMIT,
} from '@/features/shared/Payouts/constants/payouts';
import {selectDateRange, selectPollingInterval} from "@/processes/Settings";
import BarChart from '@/shared/ui/charts/BarChart';
import { useMinerAccount } from "@/processes/MinerAccounts";

type PayoutsBarChartProps = {
  className?: string;
}

const PayoutsBarChart = (props: PayoutsBarChartProps) => {
  const { className } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const dateRange = useSelector(selectDateRange);
  const { miner, coin } = useMinerAccount();

  const {
    data = {},
    isSuccess,
  } = useGetTransactionsSharedQuery({
    miner,
    coin,
    limit: LIMIT,
    sortBy: `${ORDER.DESC}${SORT_BY.CREATED_AT}`,
    offset: 0,
  }, { pollingInterval, skip: !(miner && coin) })

  const total = _get(data, 'total', []);
  const transactions = useMemo(() => {
    return _sortBy(
      _get(data, 'items', []).filter((transaction: any) => transaction.status === STATUSES.SUCCESS),
      'createdAt',
    )
  }, [total]); // eslint-disable-line
  return (
    <>
      <BarChart
        isLoading={!isSuccess}
        className="w-full h-[220px] mt-6"
        data={transactions}
        XAxisProps={{
          dataKey: 'createdAt',
          formatter: (value) => formatChartDate({ date: value, locale: intl.locale, dateRange: 'm', ...getBoundaryTimestamps(transactions) }),
        }}
        YAxisProps={{
          dataKey: 'amount',
          // formatter: (value) => formatChartDate({ date: value, locale: intl.locale }),
          domain: [0, 'auto'],
          allowDecimals: true
        }}
        tooltipLabelFormatter={(value) => formatChartDate({ date: value, locale: intl.locale })}
        lines={[
          {
            name: intl.formatMessage({ id: 'payout' }),
            dataKey: "amount",
            stroke: "#00CCAA",
          },
        ]}
      />
    </>
  );
}

export default PayoutsBarChart;
